export default __webpack_public_path__ + "static/media/IMG13.bdd94c17.png";